import { getLocalStorage } from '@shared/core';
import { addError } from '@shared/utils/logger';
import type { UploadedPreviewImage, UploadedPreviewImages } from '@shared/components/PreviewWithPhoto/PreviewWithPhoto.types';

export const getPreviewImageFromStorage = (storageKey: string, eventId: string): UploadedPreviewImages | null => {
  const key = `${storageKey}_${eventId}`;
  try {
    const raw = getLocalStorage().getItem(key) || '';
    if (!raw) return null;
    const parsed = JSON.parse(raw) as UploadedPreviewImage | UploadedPreviewImages;
    // Backward compat: old format stored a single object; new format stores an array
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch (err) {
    addError(err, { source: 'getPreviewImageFromStorage', storageKey, eventId });
    try {
      getLocalStorage().removeItem(key);
    } catch {
      // Intentionally swallowed — the corrupt payload stays, but the original
      // parse failure is already logged.
    }
    return null;
  }
};
